import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    description,
    location,
    timezone,
    area,
    project,
    status,
    profileImage,
    collectIP,
    signShift,
  },
} = checkout;

export default Yup.object().shape({
  [description.name]: Yup.string().required(description.errorMsg),
  [location.name]: Yup.string().required(location.errorMsg),
  [timezone.name]: Yup.string().required(timezone.errorMsg),
  [area.name]: Yup.array()
    .of(
      Yup.object().shape({
        lat: Yup.number(),
        lng: Yup.number(),
      })
    )
    .min(3),
  [project.name]: Yup.string(), // .required(project.errorMsg),
  [status.name]: Yup.bool(),
  [profileImage.name]: Yup.bool(),
  [collectIP.name]: Yup.bool(),
  [signShift.name]: Yup.bool(),
});
